import { z } from "zod";
import { Currency, HireUnitType, Region } from "@/gql/graphql";

export const createOrganisationValidation = z.object({
  name: z.string().min(3),
  region: z.nativeEnum(Region),
  currency: z.nativeEnum(Currency),
  hire_unit_type: z.nativeEnum(HireUnitType),
  fleet_size: z
    .number({ error: "Fleet size is required" })
    .int()
    .min(1, "Fleet size must be at least 1"),
  description: z
    .string({ error: "Description is required" })
    .min(10, "Please tell us a little more about your fleet requirements")
    .max(1000),
});
